import { message } from "../antdMessageBridge";

export const MANUAL_ENTRY_DISABLED_MESSAGE =
    "Manual entry is disabled for this field. Please tap the camera icon to scan the barcode";

export const showManualEntryDisabledWarning = (customMessage = MANUAL_ENTRY_DISABLED_MESSAGE) => {
    message.warning(customMessage);
};
